import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formContents", "tipContents"]

  dismissTip(event) {
    event.preventDefault()
    this.tipContentsTarget.classList.add("d-none")
    this.tipContentsTarget.classList.remove("col-md-6")
    this.formContentsTarget.classList.remove("col-md-6")
    this.formContentsTarget.classList.add("col-12")
  }
}
